import { Dispatch, SetStateAction, createContext } from 'react'

export const ThemeContext = createContext<{
  theme: string
  settheme: Dispatch<SetStateAction<string>>
}>({
  theme: null,
  settheme: null,
})
